module.exports = "/virtual-football-league/img/amblems/right/logos/Bordeaux.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/Bordeaux.png
// module id = 2161
// module chunks = 4